import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AvatarClickEvent } from './avatar.interface'

@Component({
  selector: 'flo-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent implements OnInit {
  @Output() public avatarSelected = new EventEmitter<AvatarClickEvent>()
  @Input() id: number
  @Input() image: string
  @Input() primaryLabel?: string
  @Input() removable?: boolean
  @Input() secondaryId?: number
  @Input() secondaryLabel?: string
  @Input() segmentName?: string
  @Input() selected: boolean
  @Input() disabled = false

  analytics?: { selected: boolean }
  public avatarClicked = () => {
    if (this.disabled) {
      return
    }
    this.selected = !this.selected
    this.analytics = { selected: this.selected }
    const data: AvatarClickEvent = {
      id: this.id,
      secondaryId: this.secondaryId,
      selected: this.selected
    }
    this.avatarSelected.emit(data)
  }

  ngOnInit(): void {
    this.segmentName = this.segmentName || `Avatar - ${this.primaryLabel} clicked`
    this.analytics = { selected: this.selected }
  }
}
